<template>
    <div class="edit_wrap">
        <div class="add_top">
            <div class="add_tab active_tab">添加品类</div>
        </div>
        <div class="pl20 pr20">
            <div class="add_brand mt20">
                <!-- 中英文名称 -->
                <div class="add_name mt20">
                    <div class="ml26">
                        <span class="main_word mr4">*</span>
                        <span class="vm form_color mr8">已有品牌：</span>
                        <el-select class="vm" v-model="brandInfo.brandId" placeholder="请选择品牌" @change="selectBrand()">
                            <el-option v-for="val in brands" :label="val.brandName" :value="val.brandId" :key="val.brandId">
                            </el-option>
                        </el-select>
                    </div>

                    <div class="c_name mt20">
                        <span class="main_word mr4">*</span>
                        <span class="form_color mr8">品牌中文名称：</span>
                        <span v-if="!alSelect" class="main_word f12">根据您选择的大V店已有品牌，系统自动填充中文名称</span>
                        <span v-else class="ml8">{{ brandInfo.brandName }}</span>
                    </div>
                    <div class="e_name mt20">
                        <span class="main_word mr4">*</span>
                        <span class="form_color mr8">品牌英文名称：</span>
                        <span v-if="!alSelect" class="main_word f12">根据您选择的大V店已有品牌，系统自动填充英文名称</span>
                        <span v-else class="ml8">{{ brandInfo.brandEnname }}</span>
                    </div>
                </div>
            </div>

            <div class="mt20">
                <el-form :model="brandInfo" label-width="129px" class="demo-ruleForm">
                    <!--品牌合作品类-->
                    <el-form-item label="品牌合作品类：">
                        <!--一级类目-->
                        <el-select class="vtb" v-model="cata.first" placeholder="请选择一级类目"
                                   @change="getTowList">
                            <el-option v-for="val in oneList" :label="val.name" :value="val.id" :key="val.id">
                            </el-option>
                        </el-select>
                        <!--二级类目-->
                        <el-select class="vtb" v-model="cata.second" placeholder="请选择二级类目"
                                   @change="getThreeList">
                            <el-option v-for="val in twoList" :label="val.name" :value="val.id"
                                       :key="val.id">

                            </el-option>
                        </el-select>
                        <!--三级类目-->
                        <el-select class="vtb" @change="selectInfo" v-model="cata.categoryId"
                                   placeholder="请选择三级类目">
                            <el-option v-for="val in threeList" :label="val.name" :value="val.id"
                                       :key="val.id"></el-option>
                        </el-select>
                        <el-button class="vtb" type="primary" @click="addDomain">添加合作类目</el-button>
                    </el-form-item>

                    <!--表格-->
                    <!--表格-->
                    <el-table :data="brandInfo.categories" border style="width: 100%;margin: 0 auto;margin-bottom:22px">
                        <el-table-column label="主营品类"
                                         width="200"
                                         align="center">
                            <template scope="scope">
                                <span>{{ scope.row.category.grandName }}--</span>
                                <span>{{ scope.row.category.parentName }}--</span>
                                <span>{{ scope.row.category.childrenName }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column label="是否提供发票"
                                         width="150"
                                         align="center">
                            <template scope="scope">
                                <el-radio-group v-model="scope.row.provideInvoice" @change="selProvideInvoice(scope.row,scope.store)" :disabled="provideInvoice != null">
                                    <el-radio :label="0"><span class="f14 f666">否</span></el-radio>
                                    <el-radio :label="1"><span class="f14 f666">是</span></el-radio>
                                </el-radio-group>
                            </template>
                        </el-table-column>

                        <el-table-column label="发票类型" align="center" width="180">
                            <template scope="scope">
                                <el-select :disabled="scope.row.provideInvoice==0" @change="selInvoiceType(scope.row)"
                                           v-model="scope.row.invoiceType"
                                           placeholder="请选择发票类型">
                                    <el-option v-if="registeredCountry == 1"  label="增值税普通发票" :value="1"></el-option>
                                    <el-option v-if="registeredCountry == 1 && taxpayerType==1" label="增值税专用发票" :value="2"></el-option>
                                    <el-option v-if="registeredCountry == 1 && taxpayerType==2" label="增值税专用发票（需去税务局代开）" :value="2"></el-option>
                                    <el-option v-if="registeredCountry != 1" label="形式发票" :value="3"></el-option>
                                </el-select>
                            </template>
                        </el-table-column>

                        <el-table-column label="税率" align="center" min-width="200">
                            <template scope="scope"
                                      v-if="scope.row.ratesStr != null && scope.row.ratesStr != undefined ">
                                <el-radio-group v-model="scope.row.ratesStr" v-if="taxpayerType==1 && scope.row.invoiceType==1">
                                    <el-radio :disabled="scope.row.provideInvoice==0" style="margin-left:0px;" label="0">0%</el-radio>
                                    <el-radio :disabled="scope.row.provideInvoice==0" style="margin-left:0px;" label="6">6%</el-radio>
                                    <br>
                                    <el-radio :disabled="scope.row.provideInvoice==0" style="margin-left:0px;" label="9">9%</el-radio>
                                    <el-radio :disabled="scope.row.provideInvoice==0" style="margin-left:0px;" label="10">10%</el-radio>
                                    <br>
                                    <el-radio :disabled="scope.row.provideInvoice==0" style="margin-left:0px;" label="13">13%</el-radio>
                                    <el-radio :disabled="scope.row.provideInvoice==0" style="margin-left:0px;" label="16">16%</el-radio>
                                </el-radio-group>
                                <el-radio-group v-model="scope.row.ratesStr" v-if="taxpayerType==1 && scope.row.invoiceType==2">
                                    <el-radio :disabled="scope.row.provideInvoice==0" style="margin-left:0px;" label="6">6%</el-radio>
                                    <el-radio :disabled="scope.row.provideInvoice==0" style="margin-left:0px;" label="9">9%</el-radio>
                                    <el-radio :disabled="scope.row.provideInvoice==0" style="margin-left:0px;" label="10">10%</el-radio>
                                    <br>
                                    <el-radio :disabled="scope.row.provideInvoice==0" style="margin-left:0px;" label="13">13%</el-radio>
                                    <el-radio :disabled="scope.row.provideInvoice==0" style="margin-left:0px;" label="16">16%</el-radio>
                                </el-radio-group>
                                <el-radio-group v-model="scope.row.ratesStr" v-if="taxpayerType==2">
                                    <el-radio :disabled="scope.row.provideInvoice==0" label="0">0%</el-radio>
                                    <el-radio :disabled="scope.row.provideInvoice==0" label="3">3%</el-radio>
                                </el-radio-group>
                            </template>
                        </el-table-column>

                        <el-table-column width="200" label="品类经营特许资质电子版" align="center">
                            <template scope="scope" >
                                <el-upload class="hide_up" v-show="scope.row.franchiseQualification"
                                           style="max-height: 149px;overflow: hidden;"
                                           action="/suppliers/uploadImageData?biz=0"
                                           name="pic"
                                           :data="{data:scope.$index}"
                                           list-type="picture-card"
                                           :file-list="scope.row.franchiseQualificationFile"
                                           :on-preview="handlePictureCardPreview"
                                           :on-remove="handleRemove"
                                           :on-success="handleUpload"
                                           :before-upload="beforeUpload"
                                >
                                    <i class="el-icon-plus"></i>
                                </el-upload>
                                <span v-if="!scope.row.franchiseQualification == 1">不需要</span>
                            </template>
                        </el-table-column>

                        <el-table-column label="操作" width="76" align="center">
                            <template scope="scope">
                                <el-button
                                        size="small"
                                        type="danger"
                                        @click="deleteDomain(scope.$index, brandInfo.categories)">删除
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>


                </el-form>
                <div align="center" class="mb20">
                    <el-button class="mr10" type="primary" @click="cancel()">取消</el-button>
                    <el-button type="primary" @click="submit()">保存</el-button>
                </div>
            </div>

            <!--预览图片-->
            <el-dialog :visible.sync="dialogVisible" size="small">
                <img width="100%" :src="dialogImageUrl" alt="">
            </el-dialog>
        </div>
    </div>
</template>


<script type="text/javascript">
    export default {
        data () {
            return {
                registeredCountry: 0,   // 注册地
                taxpayerType: 0,        // 纳税人类型
                deptId:0,               // 部门id,
                categoryDeptId:null,       // 主要为了根据部门获取品类信息,（暂时废弃）

                initBook: false,        // 初始化图书可选
                initNotBook: false,     // 初始化非图书可选

                provideInvoice:null,

                brandType: [],          // 品牌合作类型

                brandAgreementId: 0,
                brandApplyId: 0,
                brandApplyParentId:0,   // 品牌父申请id

                alSelect: false,	    // 已选择 品牌

                brands: [],           // 已有品牌列表

                isBook: true,          // 是否为图书类型

                // 图片预览
                dialogImageUrl: '',
                dialogVisible: false,

                // 合作品类 1 2 3级id
                cata: {
                    first: null,
                    second: null,
                    categoryId: null
                },
                oneList: [],            // 一级类目列表
                twoList: [],            // 二级类目列表
                threeList: [],          // 三级类目列表

                // 品类tpm
                tpmList: {},

                dateTime: "",           // 组件 质检日期

                // 提交数据
                brandInfo: {
                    brandId: null,      // 品牌
                    brandName: '',      // 中文名称
                    brandEnname: '',    // 英文名称


                    // 品类表格列表
                    categories: [

                    ],
                }
            }
        },
        mounted () {
            this.$nextTick(function () {
                var _this = this;
                var brandAgreementId = this.$route.query.brandAgreementId;
                var brandApplyId = this.$route.query.brandApplyId;
                this.brandAgreementId = brandAgreementId;
                this.brandApplyId = brandApplyId;
                this.getCategory();
                this.getBrandList();
                if (brandApplyId != 0) {
                    this.fetch(brandApplyId)
                } else {
                    $.get({
                        url: '/suppliers/agreementApply/brandApplyAttachCondition/find',
                        data: {
                            agreementApplyId: _this.brandAgreementId
                        },
                        success: function (result) {
                            if (!result.code && result.data) {
                                _this.provideInvoice = result.data.provideInvoice;
                                _this.registeredCountry = result.data.registeredCountry;
                                _this.taxpayerType = result.data.taxpayerType;
                                _this.deptId = result.data.deptId;
                                if (result.data.categoryIsBook==1 && result.data.categoryNotBook==1) {
                                    _this.brandType = ["1","2"];
                                    _this.initBook = false;
                                    _this.initNotBook = false;
                                    _this.getCategory(3);
                                } else if (result.data.categoryIsBook==1 && result.data.categoryNotBook==0) {
                                    _this.brandType = ["1"]
                                    _this.initBook = false;
                                    _this.initNotBook = true;
                                    _this.getCategory(1);
                                } else if (result.data.categoryIsBook==0 && result.data.categoryNotBook==1) {
                                    _this.brandType = ["2"];
                                    _this.initBook = true;
                                    _this.initNotBook = false;
                                    _this.getCategory(2);
                                }
                            } else {
                                _this.$message.error(result.msg)
                            }
                        }
                    })
                }
            })
        },
        methods: {
            fetch (brandApplyId) {
                var _this = this;
                $.get({
                    url: "/suppliers/agreementApply/brandApply/find",
                    data: {
                        brandApplyId: _this.brandApplyId
                    },
                    success: function (result) {
                        if (!result.code && result.data) {
                            _this.registeredCountry = result.data.registeredCountry;
                            _this.taxpayerType = result.data.taxpayerType;
                            _this.deptId = result.data.deptId;
                            _this.categoryDeptId = result.data.deptId;
                            _this.registeredCountry = result.data.registeredCountry;
                            _this.taxpayerType = result.data.taxpayerType;
                            _this.deptId = result.data.deptId;
                            _this.brandInfo = result.data;
                            if (result.data.brandId) {
                                _this.alSelect = true;
                            }
                            _this.brandAgreementId = result.data.brandAgreementId;
                            _this.brandApplyId = result.data.brandApplyId;


                            if (result.data.categoryIsBook==1 && result.data.categoryNotBook==1) {
                                _this.brandType = ["1","2"];
                                _this.initBook = false;
                                _this.initNotBook = false;
                                _this.getCategory(3);
                            } else if (result.data.categoryIsBook==1 && result.data.categoryNotBook==0) {
                                _this.brandType = ["1"]
                                _this.initBook = false;
                                _this.initNotBook = true;
                                _this.getCategory(1);
                            } else if (result.data.categoryIsBook==0 && result.data.categoryNotBook==1) {
                                _this.brandType = ["2"];
                                _this.initBook = true;
                                _this.initNotBook = false;
                                _this.getCategory(2);
                            }
                            _this.provideInvoice = result.data.provideInvoice;
                            _this.brandInfo.categories = result.data.categories;
                            if(_this.brandInfo.categories.length>0){
                                for (var i=0;i<_this.brandInfo.categories.length;i++) {
                                    // _this.brandInfo.categories[i].deptId = _this.brandInfo.categoryDeptId;
                                    if (_this.brandInfo.categories[i].franchiseQualification){
                                        _this.brandInfo.categories[i].franchiseQualificationFile = _this.fileTrans(_this.brandInfo.categories[i].franchiseQualificationFile)
                                    }else{
                                        _this.brandInfo.categories[i].franchiseQualificationFile = [];
                                    }
                                }
                            }

                            _this.brandInfo.businessType = result.data.businessType;
                            _this.brandInfo.goodsType = result.data.goodsType;



                        }
                    }
                })
            },
            selectBrand () {
                var id = this.brandInfo.brandId;
                for (var i=0 ;i <this.brands.length; i++) {
                    if (id == this.brands[i].brandId) {
                        this.brandInfo.brandId = this.brands[i].brandId;
                        this.brandInfo.brandName = this.brands[i].brandName;
                        this.brandInfo.brandEnname = this.brands[i].brandEnname;
                        this.brandApplyParentId = this.brands[i].brandApplyId;
                        this.alSelect = true;
                    }
                }
            },

            // 请求 已有品牌列表
            getBrandList () {
                var _this = this;
                $.get({
                    url: '/suppliers/agreementApply/agreementBrand/find',
                    data: {
                        brandAgreementId: _this.brandAgreementId
                    },
                    success: function (result) {
                        if (!result.code) {
                            _this.brands = result.data;
                        } else {
                            _this.$message({
                                showClose: true,
                                message: result.msg,
                                type: 'error'
                            });
                        }
                    }
                })
            },

            // 请求一级类目
            // 请求一级类目
            getCategory (type) {
                var _this = this;
                $.get({
                    url: '/suppliers/agreementApply/categories/find',
                    data: {
                        type: '1',
                        categoryId: '',
                        deptId: _this.deptId,
                        categoryType: type
                    },
                    success: function (result) {
                        if (!result.code) {
                            _this.oneList = result.data.list;
                        } else {
                            _this.$message({
                                showClose: true,
                                message: result.msg,
                                type: 'error'
                            });
                        }
                    }
                })
            },

            // 请求二级类目
            getTowList (value) {
                this.cata.second = null;
                var _this = this;
                if (value == null) {
                    this.twoList = [];
                } else {
                    $.get({
                        url: '/suppliers/agreementApply/categories/find',
                        data: {
                            type: '2',
                            categoryId: value
                        },
                        success: function (result) {
                            if (!result.code) {
                                _this.twoList = result.data.list;
                            } else {
                                _this.$message({
                                    showClose: true,
                                    message: result.msg,
                                    type: 'error'
                                });
                            }
                        }
                    })
                }

            },
            // 请求三级类目
            getThreeList (value) {
                this.cata.categoryId = null;
                var _this = this;
                if (value == null) {
                    this.threeList = [];
                } else {
                    $.get({
                        url: '/suppliers/agreementApply/categories/find',
                        data: {
                            type: '3',
                            categoryId: value
                        },
                        success: function (result) {
                            if (!result.code) {
                                _this.threeList = result.data.list;
                            } else {
                                _this.$message({
                                    showClose: true,
                                    message: result.msg,
                                    type: 'error'
                                });
                            }
                        }
                    })
                }
            },
            // 请求合作品类   数据
            selectInfo() {
                var id = this.cata.categoryId;
                var _this = this;
                if (id != null) {
                    $.get({
                        url: '/suppliers/agreementApply/categoryAttribute/find',
                        data: {
                            categoryId: id
                        },
                        success: function (result) {
                            if (!result.code) {
                                _this.tpmList = result.data;
                                _this.tpmList.ratesStr = '';
                            } else {
                                _this.$message({
                                    showClose: true,
                                    message: result.msg,
                                    type: 'error'
                                });
                            }
                        }
                    })
                }
            },
            // 添加合作类目
            addDomain () {
                var _this = this;
                if ($.isEmptyObject(this.tpmList)) {
                    this.$message.error('请选择主营品类类目');
                } else {
                    var flag = true;
                    var categories = _this.brandInfo.categories;
                    var level = this.tpmList.category;
                    for (var i = 0; i < categories.length; i++) {
                        var categoryTmp = categories[i];
                        var hisLevel = categoryTmp.category;
                        if (flag && hisLevel.childrenId == level.childrenId) {
                            flag = false;
                        }
                    }
                    if (flag) {
                        if (this.registeredCountry != 1) {
                            this.tpmList.invoiceType = 3;
                        };

                        this.tpmList.provideInvoice = _this.provideInvoice;

                        this.tpmList.franchiseQualificationFile = this.fileTrans(this.tpmList.franchiseQualificationFile)
                        _this.brandInfo.categories.push(this.tpmList)
                        // 添加成功之后
                        this.cata.first = null;
                        this.tpmList = {};
                    } else {
                        this.$message({
                            showClose: true,
                            message: '主营品类已经添加',
                            type: 'error'
                        });
                    }
                }
            },
            // 不提供发票
            selProvideInvoice(row,store){
                var store = store.states.data;
                if(row.provideInvoice==0) {
                    row.invoiceType = null;
                    row.ratesStr = '';
                    for (var i = 0; i < store.length; i++) {
                        store[i].provideInvoice = 0;
                    }
                } else {
                    for (var i = 0; i < store.length; i++) {
                        store[i].provideInvoice = 1;
                    }
                    if (this.registeredCountry == 1) {
                        row.invoiceType = 1;
                    } else {
                        row.invoiceType = 3;
                    }
                }
            },
            // 改变发票类型 清空 税率复选框 已选
            selInvoiceType(row){
                row.ratesStr = '';
            },
            // 删除 表格列表 当前行
            deleteDomain (index, tableData) {
                tableData.splice(index, 1)
            },
            // 上传资质图片
            handleUpload(response,file) {
                var index=parseInt(response.otherData);
                if (!response.code) {
                    this.brandInfo.categories.map((item,num) => {
                        if(index == num) {
                            item.franchiseQualificationFile =  this.fileTrans(response.data);
                            item.uid = file.uid;
                        }
                        return item;
                    });
                } else {
                    this.$message({
                        showClose: true,
                        message: response.msg,
                        type: 'error'
                    });
                }
            },
            // 删除 品类信息 上传图片
            handleRemove(file) {
                this.brandInfo.categories.map((item,num) => {
                    if(item.uid && item.uid == file.uid) {
                        item.franchiseQualificationFile =  [];
                    }
                    return item;
                });
            },
            // 预览 图片
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            // 上传前验证
            beforeUpload (file) {
                const isJPG = (file.type === 'image/jpeg') || (file.type === 'image/png') || (file.type === 'image/gif') || (file.type === 'image/jpg');
                const isLt1M = file.size / 1024 / 1024 < 1;
                if (!isJPG) {
                    this.$message.error('上传图片只能是JPG、GIF、PNG等格式的图片格式!');
                    return isJPG;
                }
                if (!isLt1M) {
                    this.$message.error('上传图片大小不能超过 1MB!');
                    return isLt1M;
                }

            },
            // 提交申请品牌
            submit () {
                var _this = this;
                if (!this.brandInfo.brandId) {
                    this.$message.error("请选择已有品牌");
                    return;
                } else if (this.brandInfo.brandName == '') {
                    this.$message.error("品牌中文名称不能为空");
                    return;
                } else if (this.brandInfo.categories.length == 0) {
                    this.$message.error("请添加品牌合作品类");
                    return;
                }
                var data = {};
                data = JSON.parse(JSON.stringify(_this.brandInfo));
                // 验证税率
                if (this.registeredCountry == 1) {
                    for (var i=0; i< data.categories.length;i++) {
                        if (data.categories[i].provideInvoice == 1) {
                            if (data.categories[i].ratesStr == '') {
                                this.$message.error('请选择税率');
                                return;
                            }
                        }
                    }
                }

                // 验证特许资质图片
                for (var i=0; i< data.categories.length;i++) {
                    data.categories[i].franchiseQualificationFile = this.fileTransToString(data.categories[i].franchiseQualificationFile)
                    if (data.categories[i].franchiseQualification) {
                        if (data.categories[i].franchiseQualificationFile == '') {
                            this.$message.error('请上传品类经营特许资质电子版');
                            return;
                        }
                    }
                }

                data.registeredCountry = _this.registeredCountry;
                data.brandId = _this.brandInfo.brandId;
                data.brandAgreementId = _this.brandAgreementId;
                data.brandApplyId = _this.brandApplyId;

                data.brandApplyParentId = _this.brandApplyParentId;

                var categories = [];
                var categoriesTmp = _this.brandInfo.categories;
                for (var i = 0; i < categoriesTmp.length; i++) {
                    var categoryTmp = categoriesTmp[i];
                    var category = {};
                    category.ratesStr = categoryTmp.ratesStr;
                    if (!category.ratesStr) { // 加判断后去除
                        category.rates = [];
                    }else {
                        category.rates = [category.ratesStr];
                    }
                    category.provideInvoice = categoryTmp.provideInvoice;
                    category.invoiceType = categoryTmp.invoiceType;
                    category.franchiseQualification = categoryTmp.franchiseQualification;
                    category.franchiseQualificationFile = _this.fileTransToString(categoryTmp.franchiseQualificationFile);
                    category.categoryId = categoryTmp.category.childrenId;
                    category.categoryDeposit = categoryTmp.categoryDeposit;
                    categories.push(category);
                }
                data.categories = categories;
                $.ajax({
                    url: '/suppliers/agreementApply/supplementBrandApply/save',
                    data: JSON.stringify(data),
                    dataType: "json",
                    contentType: 'application/json;charset=utf-8',
                    type: 'POST',
                    success: function (result) {
                        if (!result.code) {
                            _this.$message({
                                message: '保存成功',
                                type: 'success'
                            });
                            setTimeout(function () {
                                _this.$router.push({
                                    path:'/supple_brand_agree?id=' + _this.brandAgreementId
                                })
                            },500)
                        } else {
                            _this.$message({
                                message: result.msg,
                                type: 'error'
                            });
                        }
                    }
                })
            },
            // 取消申请品牌
            cancel () {
                this.$confirm('取消后系统将不保存您输入的信息。', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$router.push({
                        path:'/supple_brand_agree?id=' + this.brandAgreementId
                    })
                }).catch(() => {
                    console.log("取消")
                });
            },
            // [] 图片转化成字符串
            fileTransToString(files){
                var fileStr = "";
                if(files) {
                    for(var i=0;i<files.length;i++) {
                        if(files[i].url){
                            if(i!=0) {
                                fileStr += ",";
                            }
                            fileStr += files[i].url;
                        }
                    }
                }
                return fileStr;
            },
            // 转化图片 格式[{url}]
            fileTrans(fileUrl){
                var array = [];
                if(fileUrl) {
                    var files = fileUrl.split(',');
                    for(var i=0;i<files.length;i++) {
                        var file = {};
                        file.url = files[i];
                        console.log(file);
                        array.push(file);
                    }
                }
                return array;
            },
        },
        watch: {
        },
        computed: {

        }
    }
</script>

<style type="text/css" lang="less" scoped>
    .add_name {
        padding-left: 4px;
    }
    .w325 {
        width: 325px;
    }
    .result_radio .el-radio + .el-radio {
        margin-left: 10%;
    }
    .dialog-footer {
        text-align: center;
    }
    .radio_group {
        width: 90%;
        padding-left: 15%;
        max-height: 150px;
        overflow-y: scroll;
    }
    .list_radio {
        margin-top: 10px;
        margin-left: 10%;
        width: 40%;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
    }
    .form_color {
        color: rgb(106, 72, 77);
    }
    .rule_star92 {
        position: relative;
        left:-92px;
    }
    .rule_star123 {
        position: relative;
        left:-123px;
    }
    .rule_star148 {
        position: relative;
        left:-148px;
    }
    .rule_star176 {
        position: relative;
        left:-176px;
    }
    .rule_star204 {
        position: relative;
        left:-204px;
    }
    .ml_10 {
        margin-left: -10px;
    }
    .ml200 {
        margin-left: 200px;
    }
    .w500 {
        width:500px;
    }
    .edit_wrap {
        width: 1050px;
        margin: 50px auto;
        border: 1px solid #eee;
    .add_top {
        width: 100%;
        height: 40px;
        background-color: #f9f9f9;
    }
    .add_tab {
        display: inline-block;
        width: 170px;
        height: 40px;
        text-align: center;
        line-height: 40px;
        color: #666;
        font-size: 14px;
        cursor: pointer;
    }
    .active_tab {
        border-bottom: 1px solid #ff4a7d;
        color: #ff4a7d;
    }
    }
    .ml26 {
        margin-left: 26px;
    }
</style>



// WEBPACK FOOTER //
// add_category.vue?a39b7942